import barba from '@barba/core';
import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


export default class{

	constructor(){

        barba.hooks.afterOnce((data) => {
            this.init()
        });
        barba.hooks.beforeLeave((data) => {
            window.removeEventListener("resize",this.resize)
        });
        barba.hooks.after((data) => {
            this.init()
        });

    }

    init(){

        this.faqWrap = false
        
        const faqWrap = document.querySelector("#p-faq__sec01")
        const elHeight = document.querySelector('.p-faq__content').clientHeight;
        const sliderHeight = elHeight - document.querySelector('.p-faq__img').clientHeight / 2.2;
        if(faqWrap&&(window.innerWidth > 991)){
            gsap.fromTo('.p-faq__content',{},
            {
                scrollTrigger: {
                    trigger: '.p-faq__img', 
                    start: 'top top', 
                    end:'+='+sliderHeight,
                    scrub: true, 
                    markers: true,
                    pin: true
                    //anticipatePin: 1,
                    //invalidateOnRefresh: true
                }
            });
            // this.trigger = document.querySelector('#p-faq__sec01');
            // this.elem = document.querySelectorAll('.p-faq__img');
            // if(this.elem) {
            //     this.elem.forEach((el, i) => {
            //         gsap.to(el, {
            //             scrollTrigger: {
            //                 trigger: this.trigger,
            //                 start: 'bottom 100%' ,
            //                 end: 'bottom 100%',  
            //                 pin: true,  
            //                 markers: true,
            //             }
            //         });
            //     })
            // }
        }
        this.resize()
        window.addEventListener("resize",this.resize.bind(this))

    }
    resize(){
        if(window.innerWidth > 991){
            if(this.faqWrap){
                this.faqWrap.enable()
            }
        }else{
            if(this.faqWrap){
                this.faqWrap.disable()
            }
        }
    }
}